import { makeApi } from "@zodios/core";
import { z } from "zod";

import {
  editSiteConsumptionInfosSchema,
  siteConsumptionInfosSchema,
} from "@/data/api/kili/consumption/types/consumption-infos.type";
import { heatmapConsumptionSchema } from "@/data/api/kili/consumption/types/heatmap-consumption.type";
import { monositeMissingInfosSchema } from "@/data/api/kili/consumption/types/monosite-consumption.type";
import {
  multisiteConsumptionMissingInfosSchema,
  multisiteConsumptionRequestSchema,
  multisiteConsumptionSchema,
} from "@/data/api/kili/consumption/types/multisite-consumption.type";
import { userOrganizationPerimeterSchema } from "@/data/api/kili/consumption/types/user-organization-perimeter.type";

export const consumptionApi = makeApi([
  {
    method: "get",
    path: "/site/:siteId/info",
    response: siteConsumptionInfosSchema,
    alias: "getSiteConsumptionInformations",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
  },
  {
    method: "patch",
    path: "/site/:siteId/info",
    response: z.unknown(),
    alias: "editSiteConsumptionInformations",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
      {
        type: "Body",
        name: "body",
        schema: editSiteConsumptionInfosSchema,
      },
    ],
  },
  {
    method: "get",
    path: "/site/:siteId/missing-info",
    response: monositeMissingInfosSchema,
    alias: "getSiteMissingConsumptionInfos",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
  },
  {
    method: "get",
    path: "/sites/missing-info",
    response: multisiteConsumptionMissingInfosSchema,
    alias: "getMultisiteConsumptionMissingInfos",
    parameters: [
      {
        type: "Query",
        name: "siteIds",
        schema: z.array(z.number()).optional(),
      },
    ],
  },
  {
    method: "get",
    path: "/sites/perimeter",
    response: userOrganizationPerimeterSchema,
    alias: "getUserOrganizationPerimeter",
  },
  {
    method: "post",
    path: "/sites",
    response: multisiteConsumptionSchema,
    alias: "getMultisiteConsumption",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: multisiteConsumptionRequestSchema,
      },
    ],
  },
  {
    method: "get",
    path: "/heatmap",
    response: heatmapConsumptionSchema,
    alias: "getHeatmapPoints",
    parameters: [
      {
        type: "Query",
        name: "siteIds",
        schema: z.array(z.number()).optional(),
      },
    ],
  },
]);
